/**
 * Shared color constants for inline styles.
 *
 * Use these instead of hardcoding hex values. For class-based styling,
 * use the SCSS variables in _variables.scss instead.
 */

// Brand colors
export const BRAND_PRIMARY = '#45606B';
export const ACCENT_BLUE = '#007bc4';

// Status colors
export const WARNING_ORANGE = '#FFA244';
export const CONFIRM_YELLOW = '#faad14';
export const LINK_BLUE = '#1890ff';

// Warning banner colors
export const WARNING_BG = '#fffbe6';
export const WARNING_BORDER = '#ffe58f';

// Clinical/prediction status
export const SUCCESS_GREEN = '#3AAA35';
export const PATHOGENIC_RED = '#FF4444';
export const OVERRULED_RED = '#cc0000';

// Text colors
export const DISABLED_TEXT = '#9e9e9e';
export const MUTED_TEXT = '#999';
